
import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../../commonFunctions";
  
  const rbirports = {
    label: "RBI Reports",
    pageLabel: "RBI Reports",
    starting: true,
    url: "rbirports",
    pageType: "history",
    formTabs: {
        allTabs: [
            { label: "Maintain Financial Structure", uid: "maintainfinacial", style: { fontFamily: "verdana" } },
        ]
    } ,    
    form: [
        {
            inputType: "displaytext",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Code",
            name: "",
            description: "Enter Code"
          },
          {
            inputType: "text",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: " Code",
            name: "Code",
            description: "Enter Code"
          },
          {
            inputType: "text",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Search",
            name: "Search",
            description: "Enter Search"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Expand Tree Nodes",
            name: "ExpandTreeNodes",
            description: "Expand Tree Nodes"
          },
          {
            inputType: "displaytext",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Description",
            name: "",
            description: "Enter Description"
          },
          {
            inputType: "text",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Description",
            name: "Description",
            description: "Enter Description"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Set Active",
            name: "SetActive",
            description: "Set Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Has Temporary Nodes",
            name: "HasTemporaryNodes",
            description: "Has Temporary Nodes"
          },
          {
            inputType: "displaytext",
            tab: "maintainfinacial",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Report Type",
            name: "",
            description: "Enter Report Type"
          },
          {
            inputType: "select",
            tab: "maintainfinacial",
            default: "",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "General Reports",
                value: "General_Reports"
              },
              {
                label: "CashBook Group",
                value: "CashBook_Group"
              },
              {
                label: "Risk Weightage Percent",
                value: "Risk_WeightagePercent"
              },
              {
                label: "ALM",
                value: "ALM"
              },
              {
                label: "RBI Reports",
                value: "RBI_Reports"
              },
              {
                label: "NABARD",
                value: "NABARD"
              },
             ],
            placeHolder: "Report Type",
            name: "ReportType",
            description: "Enter Report Type"
          },
    ]
}

export default rbirports;